module.exports = __webpack_public_path__ + "static/media/X46MK2-logo.67fc45f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/X46MK2/X46MK2-logo.svg
// module id = 290
// module chunks = 0